import { Box, Button, SimpleGrid, useToast } from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import React from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getAnswers } from "redux/slices/answersSlice";
import { getCourses } from "redux/slices/coursesSlice";
import { setIndex } from "redux/slices/currentCourseSlice";
import { selectCurrentFormation } from "redux/slices/currentFormationSlice";
import { selectCurrentTest, setQuestions } from "redux/slices/currentTestSlice";
import { selectPassTest, setPassedTests } from "redux/slices/passTestSlice";
import { selectUserAnswersData } from "redux/slices/userAnswersSlice";
import { getProfileData } from "redux/slices/userSlice";
import { Answer } from "types";
import SingleQuestion from "../components/SingleQuestion";

export default function Questions() {
  const user = useAppSelector(getProfileData);
  const { currTest, index, questions } = useAppSelector(selectCurrentTest);
  const [answers, setAnswers] = React.useState<Answer[]>([]);
  const globalAnswers = useAppSelector(getAnswers).answers;
  const dispatch = useAppDispatch();
  const { passedTests, current } = useAppSelector(selectPassTest);
  const { currFormation } = useAppSelector(selectCurrentFormation);
  const { courses } = useAppSelector(getCourses);
  const toast = useToast();
  const userAnswers = useAppSelector(selectUserAnswersData).answers;
  const submitHandler = async () => {
    try {
      const passTestResponse = await axios.post(`${apiurl}/pass-test`, {
        test: {
          connect: {
            id: currTest.id,
          },
        },
        user: {
          connect: {
            id: user.userId,
          },
        },
      });

      if (passTestResponse.data) {
        const scoreRes = await axios.post(
          `${apiurl}/test/calculateScore?testId=${currTest.id}`,
          {
            userAnswers,
          }
        );

        toast({
          title: "Test passé",
          description:
            scoreRes.data.score >= 90
              ? "Vous avez passer le test avec succés, vous pouvez consulter votre certificat dans votre profil"
              : "Vous avez faillure le test!",
          status: scoreRes.data.score >= 90 ? "success" : "warning",
          duration: 5000,
          isClosable: true,
        });
        dispatch(setPassedTests([...passedTests, scoreRes.data]));
      }
      console.log(passTestResponse.data);
    } catch (error) {
      console.log(error);
    }
  };
  const navigateToQuestions = (e: React.MouseEvent) => {
    dispatch(setIndex(index + 1));
    e.preventDefault();
    history.push("/test/get");
  };
  const history = useHistory();
  const readCourse = (e: React.MouseEvent) => {
    e.preventDefault();
    console.log({ currTest });
    history.push("/course/read");
  };
  React.useEffect(() => {
    const getData = async (testId: any) => {
      try {
        const res = await axios.get(`${apiurl}/question/test/${testId}`);
        dispatch(setQuestions([...res.data]));
      } catch (error) {
        console.log(error);
      }
    };
    getData(currTest.id);
  }, []);
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid columns={{ base: 1, md: 1 }} gap="20px">
        {questions &&
          questions.map((question, index) => {
            return (
              <SingleQuestion
                prevTimeout={index === 0 ? 0 : question.responseTimeout * index}
                id={question.id}
                content={question.content}
                responseTimeout={question.responseTimeout}
                addedOn={new Date(question.addedOn)}
                lastModifiedOn={new Date(question.lastModifiedOn)}
                testId={question.testId}
                questionTypeId={0}
              />
            );
          })}
        {/*<CoursesTable loading={false} tableData={useTableDataCheck().filter(course=>course.formation === currFormation.title)} />*/}
        <Button onClick={() => submitHandler()} colorScheme={"brandScheme"}>
          Valider
        </Button>
      </SimpleGrid>
    </Box>
  );
}
